import request from "./request";
import requestJson from "./request2";
import qs from "qs";
import axios from "axios";

let baseURL = process.env.VUE_APP_BASE_URL;
let token = sessionStorage.getItem("token");
let authApiprefix = "/oa-auth";
let adminApiprefix = "/oa-lowcode-admin";
let platformApiprefix = "/oa-platform";
// 用户名密码获取token
// export const goLogin = (data) => request.post('/oauth/user/token', qs.stringify(data));

// 当前登陆用户信息
export const userInfo = () => request.get(authApiprefix + "/oauth/userinfo");

// 平台登录获取token
export const goLogin = async (data) => {
  let url = baseURL + authApiprefix + "/oauth/user/token";
  return await axios({
    method: "POST",
    url: url,
    headers: {
      client_id: "system",
    },
    data: qs.stringify(data),
  });
};

// 企业登录获取token
export const userGoLogin = async (data) => {
  let url = baseURL + authApiprefix + "/oauth/user/token";
  return await axios({
    method: "POST",
    url: url,
    headers: {
      client_id: "platform",
    },
    data: qs.stringify(data),
  });
};

// 刷新token
export const refreshToken = async (data) => {
  let url = baseURL + authApiprefix + "/oauth/refresh/token";
  return await axios({
    method: "POST",
    url: url,
    headers: {
      Authorization: "Bearer " + token,
    },
    data: qs.stringify(data),
  });
};

// 企业确认登录
export const comfirmLogin = (data) =>
  request.post(authApiprefix + "/oauth/comfirm_login", qs.stringify(data));

// 退出登录
export const logout = () => request.post(authApiprefix + "/logout");

// 企业开通账号
export const corporateAdd = (data) =>
  requestJson.post(adminApiprefix + "/corporate/add", data);

//企业列表
export const corporateList = (params) =>
  request.get(adminApiprefix + "/corporate/list", { params });

// 企业账号状态修改
export const corporateState = (data) =>
  request.put(adminApiprefix + "/corporate/state", qs.stringify(data));

//查看企业账号
export const corporateView = (params) =>
  request.get(adminApiprefix + "/corporate/view", { params });

// 添加管理用户
export const sysuserAdd = (data) =>
  requestJson.post(adminApiprefix + "/sysuser/add", data);

// 查询管理用户列表
export const sysuserList = (params) =>
  request.get(adminApiprefix + "/sysuser/list", { params });

//删除管理员用户
export const deleteSysuser = (id) =>
  request.delete(adminApiprefix + "/sysuser/delete?userId=" + id);

// 启用-禁用用户状态
export const sysuserState = (data) =>
  request.put(adminApiprefix + "/sysuser/state", qs.stringify(data));

// 组件日志列表
export const componentLogList = (params) =>
  request.get(adminApiprefix + "/componentLog/list", { params });

// 获取权限菜单列表
export const getMenuList = (params) =>
  request.get(adminApiprefix + "/corporate/menu/list", { params });

// 新增权限菜单
export const addMenu = (data) =>
  requestJson.post(adminApiprefix + "/corporate/menu/add", data);

// 修改权限菜单
export const updateMenu = (data) =>
  requestJson.put(adminApiprefix + "/corporate/menu/update", data);

// 删除权限菜单
export const adminProcessGroupDel = (id) =>
  request.delete(adminApiprefix + `/process/group/del/${id}`);

// 平台端模板管理
export const processGroupCreate = (data) =>
  requestJson.post(adminApiprefix + "/process/group/create", data);

// 平台端获取模板列表
export const processListAll = (params) =>
  request.get(
    adminApiprefix +
    "/process/list/all?" +
    qs.stringify(params, { arrayFormat: "repeat" })
  );

// 删除分组
export const deleteMenu = (id) =>
  request.delete(adminApiprefix + "/corporate/menu/delete/" + id);

// 修改分组
export const processGroupModify = (data) =>
  requestJson.put(adminApiprefix + "/process/group/modify", data);

// 分组排序
export const adminProcessGroupSort = (data) =>
  requestJson.put(adminApiprefix + "/process/group/sort", data);

// 获取分组列表
export const adminProcessGroupList = (params) =>
  request.get(adminApiprefix + "/process/group/list", { params });

// 移动流程到新分组
export const adminProcessMovedGroup = (data) =>
  request.put(adminApiprefix + "/process/moved/group", qs.stringify(data));

// 流程启用-禁用
export const adminProcessState = (data) =>
  request.put(adminApiprefix + "/process/state", qs.stringify(data));

// 分组排序
export const adminProcessUpdateSort = (data) =>
  requestJson.put(adminApiprefix + "/process/update/sort", data);

// 删除流程模板
export const adminProcessDelete = (params) =>
  request.delete(adminApiprefix + "/process/delete", { params });

// 添加角色组
export const roleGroupAdd = (data) =>
  requestJson.post(platformApiprefix + "/corporate/role/group/add", data);

// 获取角色treeList
export const roleTreeList = () =>
  request.get(platformApiprefix + "/corporate/role/tree/list");

// 获取角色用户列表
export const roleUserList = (params) =>
  request.get(platformApiprefix + "/corporate/role/user/list", { params });

// 删除角色组
export const deleteRoleGroup = (roleGroupId) =>
  request.delete(
    platformApiprefix + `/corporate/role/${roleGroupId}/group/delete`
  );

// 修改角色组
export const roleGroupUpdate = (data) =>
  requestJson.put(platformApiprefix + "/corporate/role/group/update", data);

// 获取全部员工
export const corporateStaff = () =>
  request.get(platformApiprefix + "/corporate/staff/list/all");

// 获取操作日志列表
export const corporateLogList = (params) =>
  request.get(platformApiprefix + "/corporate/operation/log/list", { params });

// 获取企业信息
export const corporateInfo = () =>
  request.get(platformApiprefix + "/corporate/info");

// 修改企业信息
export const updateCorporateInfo = (data) =>
  requestJson.put(platformApiprefix + "/corporate/info/update", data);

// 获取密钥管理
export const corporateAccess = () =>
  request.get(platformApiprefix + "/corporate/security/access");

// 修改企业Secret
export const updateCorporateAccess = () =>
  request.put(platformApiprefix + "/corporate/security/update/access");

// 获取管理员维护列表
export const corporateSecurityList = (params) =>
  request.get(platformApiprefix + "/corporate/security/admin/list", { params });

// 获取创始人
export const getCorporateFounder = () =>
  request.get(platformApiprefix + "/corporate/security/getFounder");

// 发送验证码
export const sendVerificationCode = (data) =>
  requestJson.post(
    platformApiprefix + "/corporate/security/send/verificationCode",
    data
  );

// 确认原创始人身份
export const checkCorporateFounder = (data) =>
  request.post(
    platformApiprefix + "/corporate/security/check/founder",
    qs.stringify(data)
  );

// 通过企业员工名或手机号获取员工
export const getcorporateStaff = (params) =>
  request.get(platformApiprefix + "/corporate/security/getStaff", { params });

// 转让
export const transferCorporateFounder = (data) =>
  requestJson.post(
    platformApiprefix + "/corporate/security/transfer/founder",
    data
  );

// 添加管理员
export const addCorporateStaff = (data) =>
  requestJson.post(
    platformApiprefix + "/corporate/security/add/admin/staff",
    data
  );

// 邮件模板，分页查询
export const corporateMailList = (params) =>
  request.get(platformApiprefix + "/corporateMail/list", { params });

// 邮件模板，查询角色
export const corporateMailRoles = () =>
  request.get(platformApiprefix + "/corporateMail/queryRoles");

// 邮件模板，查询角色组
export const corporateMailRoleGroup = () =>
  request.get(platformApiprefix + "/corporateMail/queryRoleGroup");

// 邮件模板，查询部门
export const corporateMailDepartments = () =>
  request.get(platformApiprefix + "/corporateMail/queryDepartments");

// 邮件模板，通过主键查询单条数据
export const corporateMailInfo = (params) =>
  request.get(platformApiprefix + "/corporateMail/queryById", { params });

// 邮件模板，编辑数据
export const updateCorporateMailInfo = (data) =>
  request.put(platformApiprefix + "/corporateMail/edit", qs.stringify(data));

// 删除管理员
export const deleteCorporateStaff = (id) =>
  request.delete(
    platformApiprefix + "/corporate/security/del/" + id + "/admin/staff"
  );

// 获取权限菜单
export const corporateRoleMenus = () =>
  request.get(platformApiprefix + "/corporate/role/menus");

// 获取角色组列表
export const roleGroupList = () =>
  request.get(platformApiprefix + "/corporate/role/group/list");

// 添加角色
export const roleAdd = (data) =>
  requestJson.post(platformApiprefix + "/corporate/role/add", data);

// 编辑角色
export const roleUpdate = (data) =>
  requestJson.put(platformApiprefix + "/corporate/role/update", data);

// 获取角色详情
export const roleInfo = (id) =>
  request.get(platformApiprefix + `/corporate/role/${id}/info`);

// 删除角色
export const deleteRole = (id) =>
  request.delete(platformApiprefix + `/corporate/role/delete/${id}`);

// 添加部门
export const departmentAdd = (data) =>
  requestJson.post(platformApiprefix + "/corporate/department/add", data);

// 获取部门树结构列表
export const departmentTreeList = () =>
  request.get(platformApiprefix + "/corporate/department/tree/list");

// 获取部门列表
export const corporateDepartment = (params) =>
  request.get(platformApiprefix + "/corporate/department/list", { params });

// 删除选中
export const deleteDepartment = (data) =>
  requestJson.delete(platformApiprefix + `/corporate/department/delete`, {
    data: data,
  });

//修改部门
export const departmentUpdate = (data) =>
  requestJson.put(platformApiprefix + "/corporate/department/update", data);

// 获取部门详情
export const departmentInfo = (id) =>
  request.get(platformApiprefix + `/corporate/department/${id}/info`);

// 批量修改部门
export const departmentBatchUpdate = (data) =>
  requestJson.put(
    platformApiprefix + "/corporate/department/batch/update",
    data
  );

// 添加人员
export const staffAdd = (data) =>
  requestJson.post(platformApiprefix + "/corporate/staff/add", data);

// 获取人员列表
export const staffList = (params) =>
  request.get(
    platformApiprefix +
    "/corporate/staff/list?" +
    qs.stringify(params, { arrayFormat: "repeat" })
  );

// 删除人员
export const deleteStaff = (data) =>
  requestJson.delete(platformApiprefix + `/corporate/staff/delete`, {
    data: data,
  });

// 设置主管-取消主管
export const staffDirector = (data) =>
  requestJson.post(platformApiprefix + "/corporate/staff/director", data);

// 修改人员
export const staffUpdate = (data) =>
  requestJson.put(platformApiprefix + "/corporate/staff/update", data);

// 获取人员详情
export const staffInfo = (id) =>
  request.get(platformApiprefix + `/corporate/staff/${id}/info`);

// 批量调整人员部门
export const staffBatchUpdate = (data) =>
  requestJson.put(
    platformApiprefix + "/corporate/staff/batch/update/dept",
    data
  );

// 批量删除角色成员
export const roleUnBind = (data) =>
  requestJson.post(platformApiprefix + "/corporate/role/unBind/user", data);

// 获取部门人员选人列表
export const selectStaffList = (params) =>
  request.get(platformApiprefix + "/corporate/common/select/staff/list", {
    params,
  });

// 角色添加成员
export const roleBindUser = (data) =>
  requestJson.post(platformApiprefix + "/corporate/role/bind/user", data);

// 公共分组，获取列表
export const commonGroupList = (params) =>
  request.get(adminApiprefix + "/process/group/list", {
    params,
  });

//部门设置主管
export const departmentDirector = (data) =>
  requestJson.post(platformApiprefix + "/corporate/department/director", data);

// 工作流引擎 企业端
// 新建分组
export const processGroupAdd = (data) =>
  requestJson.post(platformApiprefix + "/process/group/add", data);

// 获取分组列表
export const processGroupList = (params) =>
  request.get(platformApiprefix + "/process/group/list", {
    params,
  });

// 获取工作流列表
export const processList = (params) =>
  request.get(
    platformApiprefix +
    "/process/list?" +
    qs.stringify(params, { arrayFormat: "repeat" })
  );

// 修改
export const processGroupUpdate = (data) =>
  requestJson.put(platformApiprefix + "/process/group/update", data);

// 分组排序
export const processGroupSort = (data) =>
  requestJson.put(platformApiprefix + "/process/group/sort", data);

// 删除分组
export const processGroupDel = (id) =>
  request.delete(platformApiprefix + `/process/group/del/${id}`);

// 移动流程到新分组
export const processGroupMoved = (data) =>
  request.put(platformApiprefix + "/process/moved/group", qs.stringify(data));

// 流程启用-禁用
export const processState = (data) =>
  request.put(platformApiprefix + "/process/state", qs.stringify(data));

// 删除流程模板
export const processDelete = (params) =>
  request.delete(platformApiprefix + "/process/delete", { params });

// 流程排序
export const processUpdateSort = (data) =>
  requestJson.put(platformApiprefix + "/process/update/sort", data);

// 获取部门成员
export const departmentStaffList = (id) =>
  request.get(platformApiprefix + `/corporate/department/${id}/staff/list`);

// 获取手机号
export const corporatePhone = (params) =>
  request.get(adminApiprefix + `/corporate/phone/show`, { params });

// 流程发布
export const addFlow = (data) =>
  requestJson.post(adminApiprefix + "/process/release", data);

// 企业流程发布
export const enterpriseAddFlow = (data) =>
  requestJson.post(platformApiprefix + "/process/release", data);

// 获取流程实例列表
export const processExampleList = (params, data) =>
  requestJson.post(
    platformApiprefix +
    "/processExample/list?" + qs.stringify(params, { arrayFormat: "repeat" }), data
  );

// 流程详情
export const flowDetails = (params) =>
  requestJson.get(adminApiprefix + "/process/info", { params });

// 企业流程详情
export const enterpriseFlowDetails = (params) =>
  requestJson.get(platformApiprefix + "/process/info", { params });

// 流程草稿
export const draft = (data) =>
  requestJson.post(adminApiprefix + "/process/drafts", data);

// 企业流程草稿
export const enterpriseDraft = (data) =>
  requestJson.post(platformApiprefix + "/process/drafts", data);

// 流程编辑
export const updateFlow = (data) =>
  requestJson.post(adminApiprefix + "/process/edit", data);

// 企业流程编辑
export const enterpriseUpdateFlow = (data) =>
  requestJson.post(platformApiprefix + "/process/edit", data);

// 获取用户申请列表
export const userApplyList = (params) =>
  request.get(platformApiprefix + "/corporate/apply/user/list", { params });

// 人员申请通过
export const userApplyApproved = (data) =>
  requestJson.post(
    platformApiprefix + "/corporate/apply/user/corporateUserApplyApproved",
    data
  );

// 人员申请拒绝
export const userApplyRefuse = (data) =>
  requestJson.post(platformApiprefix + "/corporate/apply/user/refuse", data);

// 废除流程实例
export const processExampleAbolition = (data) =>
  request.post(
    platformApiprefix + "/processExample/abolition",
    qs.stringify(data)
  );

// 删除流程实例
export const processExampleDelete = (data) =>
  request.post(
    platformApiprefix + "/processExample/delProcessExample",
    qs.stringify(data)
  );

// 企业菜单
export const getUserMenu = () =>
  request.get(platformApiprefix + "/corporate/menu/router");

// 发起人弹窗数据 部门于人员
export const getDepartmentAndPersonnel = (params) =>
  request.get(platformApiprefix + "/corporate/common/deptStaff", { params });

// 获取动态菜单
export const getUserMenuAdmin = () =>
  request.get(adminApiprefix + "/admin/menu/router");

// 修改可见范围
export const updateVisible = (data) =>
  requestJson.put(platformApiprefix + "/process/update/visible", data);

// 获取全部流程
export const getAllFlow = (params) =>
  request.get(
    platformApiprefix +
    "/process/listAll?" +
    qs.stringify(params, { arrayFormat: "repeat" })
  );

// 获取全部流程
export const getPlatformAllFlow = (params) =>
  request.get(
    adminApiprefix +
    "/process/listAll?" +
    qs.stringify(params, { arrayFormat: "repeat" })
  );

// 获取公共流程列表
export const getCommonList = () =>
  request.get(platformApiprefix + "/process/common/list");

// 公共流程选用
export const commonUse = (data) =>
  request.post(platformApiprefix + "/process/common/use", qs.stringify(data));

// 流程详情-审批记录
export const processExample = (params) =>
  request.get(platformApiprefix + "/processExample/getApprovalInfoById", {
    params,
  });

// 流程详情-处理人
export const exampleHandler = (params) =>
  request.get(platformApiprefix + "/processExample/exampleHandler", {
    params,
  });

// 流程详情-处理人统计
export const exampleHandlerCount = (params) =>
  request.get(platformApiprefix + "/processExample/exampleHandlerCount", {
    params,
  });

// 流程详情-抄送人统计
export const exampleCCPersonCount = (params) =>
  request.get(platformApiprefix + "/processExample/exampleCCPersonCount", {
    params,
  });

// 流程详情-抄送人
export const exampleCCPerson = (params) =>
  request.get(platformApiprefix + "/processExample/exampleCCPerson", {
    params,
  });

// 流程详情-基本信息
export const getStaffInfoById = (params) =>
  request.get(platformApiprefix + "/processExample/getStaffInfoById", {
    params,
  });

// 企业微信内部应用-同步通讯录
export const synchronizeContacts = () =>
  request.post(platformApiprefix + "/WXPlatform/synchronizeContacts");

// 第三方应用同步通讯录
export const syncAddressBook = () =>
  request.post(platformApiprefix + "/WXPlatform/syncAddressBook");

// 公共模板接口
export const selectCommonProcess = (params) =>
  request.get(platformApiprefix + "/process/group/selectCommonProcess", {
    params,
  });

// 获取公共流程模板详情
export const processInfoProcessVO = (params) =>
  request.get(platformApiprefix + "/process/infoProcessVO", {
    params,
  });

// 通过企业id查询邮箱配置
export const corporateMailSetting = (corpId) =>
  request.get(platformApiprefix + `/corporateMailSetting/${corpId}`);

// 编辑企业邮箱数据
export const editCorporateMailSetting = (data) =>
  requestJson.put(platformApiprefix + "/corporateMailSetting", data);

// 新增企业邮箱数据
export const addCorporateMailSetting = (data) =>
  requestJson.post(platformApiprefix + "/corporateMailSetting", data);

// 忘记密码-发送邮箱验证码
export const verification = (params) =>
  request.get(platformApiprefix + "/corporate/user/send/verification/code", {
    params,
  });

// 校验验证码
export const verificationCode = (data) =>
  requestJson.post(
    platformApiprefix + "/corporate/user/send/verificationCode",
    data
  );

// 重置密码
export const changePassword = (data) =>
  requestJson.post(
    platformApiprefix + "/corporate/user/send/change/password",
    data
  );

// export const wechatLogin = (data) =>
//   request.post(authApiprefix + "/oauth/wechatInsideLogin", qs.stringify(data));
// 企业微信内部登录
export const wechatLogin = async (data) => {
  let url = baseURL + authApiprefix + "/oauth/wechatInsideLogin";
  return await axios({
    method: "POST",
    url: url,
    headers: {
      client_id: "platform",
    },
    data: qs.stringify(data),
  });
};

// 转交
export const transfer = (data) =>
  requestJson.post(platformApiprefix + "/processExample/transfer", data);

// 获取企业信息
export const corporateInfoList = (params) =>
  request.get(platformApiprefix + "/corporate/info");
// 检测是否需要登录验证码
export const needCheckCode = (params) =>
  request.get(authApiprefix + "/oauth/needCheckCode", {
    params,
  });

// 企业微信第三方登录
export const oauthWechatLogin = async (data) => {
  let url = baseURL + authApiprefix + "/oauth/wechatLogin";
  return await axios({
    method: "POST",
    url: url,
    headers: {
      client_id: "platform",
    },
    data: qs.stringify(data),
  });
};

// 创建应用级jsapiTicket签名
export const getWxJsapiSignature = (data) =>
  request.post(
    platformApiprefix + "/WXPlatform/getWxJsapiSignature",
    qs.stringify(data)
  );

// 许可证文件上传
export const licenseUpload1 = (params) =>
  request.get(adminApiprefix + "/license/upload", {
    params,
  });
// 许可证文件上传
export const licenseUpload2 = (params) =>
  request.get(platformApiprefix + "/license/upload", {
    params,
  });
// 获取机器码
export const licenseKey1 = (params) =>
  request.get(adminApiprefix + "/license/key", {
    params,
  });
// 获取机器码
export const licenseKey2 = (params) =>
  request.get(platformApiprefix + "/license/key", {
    params,
  });
// 检查许可证
// export const licenseCheck1 = (params) =>
//   requestJson.get(adminApiprefix + "/license/check", {
//     params,
//   });
// 检查许可证
// export const licenseCheck2 = (params) =>
//   requestJson.get(platformApiprefix + "/license/check", {
//     params,
//   });

// 检查许可证
export const licenseCheck1 = async () => {
  let url = baseURL + authApiprefix + "/license/check";
  return await axios({
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 检查许可证
export const licenseCheck2 = async () => {
  let url = baseURL + platformApiprefix + "/license/check";
  return await axios({
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

//下载附件
export const enclosureDownload = async (data) => {
  let url =
    baseURL +
    platformApiprefix +
    "/file/download/local" +
    "?path=" +
    data.path +
    "&access_token=" +
    sessionStorage.getItem("token");
  return await axios({
    method: "GET",
    url: url,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "content-type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    },
    responseType: "arraybuffer",
  });
};

// 数据管理---数据查看
// 获取流程模版列表
export const getDataProcessList = (params) =>
  request.get(platformApiprefix + "/dataViewing/getProcessList", {
    params,
  });
// 获取模板配置列表
export const getDataProcessInfo = (params) =>
  request.get(platformApiprefix + "/dataViewing/getProcessInfo", {
    params,
  });
// 获取用户页面配置
export const getDataView = (params) =>
  request.get(platformApiprefix + "/dataViewing/getView", {
    params,
  });
// 获取指定类型用户配置
export const getDataViewByType = (params) =>
  request.get(platformApiprefix + "/dataViewing/getViewByType", {
    params,
  });
// 分页获取流程数据
export const getDataExampleList = (params) =>
  requestJson.post(platformApiprefix + "/dataViewing/getExampleList", params);

// 更新用户配置
export const saveDataAndUpdate = (params) =>
  requestJson.post(platformApiprefix + "/dataViewing/saveAndUpdate", params);
// 数据管理-导出列
export const exportDataExcel = async (data) => {
  let url = baseURL + platformApiprefix + "/dataViewing/exportExcel";
  return await axios({
    method: "post",
    url: url,
    data: data,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "content-type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    },
    responseType: "arraybuffer",
  });
};

// 获取流程信息
export const getDataExampleInfo = (params) =>
  request.get(platformApiprefix + "/dataViewing/getExampleInfo", {
    params,
  });
// 获取归档信息
export const getDataArchivedInfo = (params) =>
  request.get(platformApiprefix + "/dataViewing/getArchivedInfo", {
    params,
  });
// 提交归档信息
export const submitDataArchive = (data) =>
  requestJson.post(platformApiprefix + "/dataViewing/submitArchive", data);
// 上传附件
export const uploadEnclosure = async (params) => {
  let url = baseURL + platformApiprefix + "/file/upload";
  return await axios({
    method: "post",
    url: url,
    data: params,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    },
  });
};
// 获取省份
export const getProvince = (params) =>
  request.get(platformApiprefix + "/district/province", {
    params,
  });
// 获取市
export const getCity = (params) =>
  request.get(platformApiprefix + "/district/city", {
    params,
  });
// 获取区
export const getArea = (params) =>
  request.get(platformApiprefix + "/district/area", {
    params,
  });
// 获取街道
export const getStreet = (params) =>
  request.get(platformApiprefix + "/district/street", {
    params,
  });
// 外部数据字典 系统列表
export const getSystemList = (params) =>
  request.get(platformApiprefix + "/connector/select/page", {
    params,
  });

// 外部数据字典 详情列表
export const getDetailsList = (params) =>
  request.get(platformApiprefix + "/connectorAction/select/list", {
    params,
  });

// 新增数据字典 系统
export const addSystem = (params) =>
  requestJson.post(platformApiprefix + "/externalSystem", params);

// 外部数据字典 列表全部查询
export const getAllList = (params) =>
  request.get(platformApiprefix + "/external/register/selectList", {
    params,
  });

// 新增数据字典 详情
export const addSystemDetails = (params) =>
  requestJson.post(platformApiprefix + "/connectorAction", params);

// 获取详情
export const getSystemDataId = (params) =>
  request.get(platformApiprefix + "/connectorAction/info", {
    params,
  });

// 修改数据字典 详情
export const updateSystemDetails = (params) =>
  requestJson.put(platformApiprefix + "/connectorAction/delete", params);

// 绑定账号
export const bindingAccount = (params) =>
  requestJson.post(platformApiprefix + "/corporateStaffOutside/add", params);

// 获取外部系统和请求参数
export const getSystemAndParameter = (params) =>
  request.get(
    platformApiprefix + "/connector/select/externalSystem/list",
    {
      params,
    }
  );

// 获取请求方法类型
export const getRequestMethod = (params) =>
  request.get(platformApiprefix + "/connectorAction/getRequestMethod");

// 新增连接工厂或修改
export const addAndpudateConnector = (params) =>
  requestJson.post(
    platformApiprefix + "/connector/saveAndUpdate",
    params
  );

// 获取数据类型
export const getDataType = () =>
  request.get(platformApiprefix + "/connectorAction/getParameterType");

// 获取连接工厂详情
export const getConnectorDetails = (params) =>
  request.get(platformApiprefix + "/connector/info", { params });

// 查询该员工绑定的账号
export const getBindEmployeeAccount = (params) =>
  request.get(platformApiprefix + "/corporateStaffOutside/selectList", {
    params,
  });
// 删除该员工绑定的账号
export const deleteBindEmployeeAccount = (id) =>
  request.delete(platformApiprefix + "/corporateStaffOutside/del?id=" + id);
// 查询黑猫的账号
export const queryBindEmployeeAccount = (params) =>
  request.get(platformApiprefix + "/corporateStaffOutside/selectBlackCatList", {
    params,
  });

// 数据统计
// 获取模版列表
export const reportselectProcessList = (params) =>
  request.get(platformApiprefix + "/reportSettings/selectProcessList", {
    params,
  });
// 获取报表列表
export const reportselectList = (params) =>
  request.get(platformApiprefix + "/reportSettings/selectList", {
    params,
  });
// 获取报表配置详情
export const reportSettingsInfo = (params) =>
  request.get(platformApiprefix + "/reportSettings/info", {
    params,
  });
// 保存报表设置-新建配置报表
export const reportSettingsSave = (params) =>
  requestJson.post(platformApiprefix + "/reportSettings/save", params);

// 修改报表设置-修改配置报表
export const reportSettingsUpdate = (params) =>
  requestJson.post(platformApiprefix + "/reportSettings/update", params);

// 获取报表行 值 筛选项
export const getReportConfigurationData = (params) =>
  request.get(
    platformApiprefix + "/reportSettings/getReportConfigurationData",
    {
      params,
    }
  );

//报表数据统计 ---报销统计表格数据
export const reportSelectDataStatistics = (params) =>
  requestJson.post(
    platformApiprefix + "/reportSettings/selectDataStatistics",
    params
  );

//导出报表
export const reportSettingsDownload = async (data) => {
  let url = baseURL + platformApiprefix + "/reportSettings/download";
  return await axios({
    method: "post",
    url: url,
    data: data,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "content-type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    },
    responseType: "arraybuffer",
  });
};

//删除报表
export const deleteReportSettings = (id) =>
  request.delete(platformApiprefix + "/reportSettings/del?id=" + id);

//删除执行动作
export const deletePerform = (id) =>
  request.delete(platformApiprefix + "/externalSystemJoggle?id=" + id);

// 删除连接器
export const deleteSystem = (id) =>
  request.delete(platformApiprefix + "/connector/delete?id=" + id);

// 查询权限
export const getAuthentication = (params) =>
  request.get(
    platformApiprefix + "/dataViewing/getAuthentication",
    {
      params,
    }
  );

// 获取默认值
export const getSystemDefault = (params) =>
  request.get(
    platformApiprefix + "/process/sys/field",
    {
      params,
    }
  );

// 修改密码
export const modifyPassword = (params) =>
  requestJson.post(adminApiprefix + "/sysuser/modifyPassword", params);

// 低代码组件日志
export const lowCodeComponentLogList = (params) =>
  request.get("/oa-lowcode-admin/componentLog/list", { params });

// 编辑资源容量
export const editResource = (params) =>
  requestJson.put(adminApiprefix + "/corporate/editResource", params);

// 获取流程模板分组
export const getGroupList = () =>
  request.get(platformApiprefix + "/processExample/getGroupList");


// 获取所在部门
export const searchCapitalUser = () =>
  request.get(platformApiprefix + "/capitaluser/searchCapitalUser");

// 获取当前员工信息
export const getCorporateStaffVO = (params) =>
  request.get(platformApiprefix + "/corporate/user/getCorporateStaffVO", { params });

// 企业端 修改密码
export const updatePassword = (data) =>
  requestJson.post(platformApiprefix + "/corporate/user/update/password", data);

// 平台端 获取当前员工信息
export const getPlatformCorporateStaffVO = (params) =>
  request.get(adminApiprefix + "/sysuser/info", { params });

// 平台端 修改密码
export const platformUpdatePassword = (data) =>
  requestJson.post(adminApiprefix + "/sysuser/editPassword", data);

// 重置应用
export const resetApplication = (data) =>
  requestJson.post(adminApiprefix + "/admin/low/code/app/resetApplication", data);

// 获取工商联列表
export const getCapitalUserList = () =>
  request.get(adminApiprefix + "/corporate/federation/list");
